// The stage-denial card (docs/design/slice4-certify-ux.md §2.3, §4.3 "Stage-denied") -
// a DISTINCT visual from the tier-refusal takeover (RefusalCard.tsx) so a founder never
// confuses "wrong plan" with "wrong stage" (D34: Certify is available from the MVP
// stage). Its "link into Build" destination is now real
// (`/apps/:appId/build`, Slice 5) - Wave 3 wires `onGoToBuild` at every call site
// (docs/phase-0/slice5-ux-flows.md §2.1 "closing LifecycleGateCard.tsx's stubbed
// onGoToBuild link for good, not only for idea-route apps"); the prop stays optional so
// a caller with nothing to wire (none remain, but defensive) still renders no dead link.
// `heading`/`body`/`buildLinkCta` are OPTIONAL overrides, each defaulting to the
// original Certify copy (byte-identical to every existing call site) - Flow 6's own
// Production-Build stage gate (`ProductionBuild.tsx`) reuses this exact component
// verbatim with its own copy via these overrides, per component-designs.md §3.6
// ("generalizes cleanly... Production Build becomes available once {appName} reaches
// MVP") rather than a second, near-duplicate gate card.
import { Link } from "react-router-dom";
import { certifyCopy } from "../copy/certify.js";

export const LifecycleGateCard = ({
  appName,
  onGoToBuild,
  heading,
  body,
  buildLinkCta,
}: {
  readonly appName: string;
  readonly onGoToBuild?: () => void;
  readonly heading?: string;
  readonly body?: string;
  readonly buildLinkCta?: string;
}): React.JSX.Element => (
  <div className="card state-card state-lifecycle" role="region" aria-label="Not yet available">
    <div className="h3">{heading ?? certifyCopy("certify.stageGate.heading", { appName })}</div>
    <p className="muted">{body ?? certifyCopy("certify.stageGate.body")}</p>
    <div className="actions">
      {onGoToBuild ? (
        <button type="button" className="btn btn-ghost" onClick={onGoToBuild}>
          {buildLinkCta ?? certifyCopy("certify.stageGate.buildLinkCta")}
        </button>
      ) : null}
      <Link className="btn btn-primary" to="/apps">
        Back to your apps
      </Link>
    </div>
  </div>
);
